import React, { useEffect, useState } from 'react';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import {
  box_container,
  table_body,
  tableData,
  table_container
} from './Disbursement.module.css';
import { faFilter } from '@fortawesome/pro-light-svg-icons';
import InfiniteScroll from '../../common/components/InfiniteScroll/InfiniteScroll';
import CircularProgress from '@material-ui/core/CircularProgress';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DateFilter from '../../common/components/PopupFilter/FilterComponents/DateFilter';
import RM from '../../common/components/PopupFilter/FilterComponents/RmList';
import rmICon from '../../images/icons/PopUpFilter/rmImg.svg';
import PopupFilter from '../../common/components/PopupFilter/PopupFilter';
import CountsOfTheFilter from '../../common/components/PopupFilter/SelectedFilters/CountsOfTheFilter';
import SvgComponent from '../../common/components/SvgComponent/SvgComponent';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import {
  getBankDisbursementDetailReport,
  getBankDisbusementSummary
} from '../../common/constants/api';
import moment from 'moment';
import numberFormat from '../../common/constants/NumberFormat';

const DisbursementUI = () => {
  const [loading, setLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({});
  const [disbursementData, setDisbursementData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [isFirstCallDone, setIsFirstCallDone] = useState(false);
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [summaryData, setSummaryData] = useState({});
  const [shoHtmlSelectedFileds, setHtmlSelectedFileds] = useState('');
  const [masterFilters, setMasterFilters] = useState(
    getFiltersInfo()?.disbursements || {}
  );
  const [disbursementFilters, setDisbursementFilters] = useState({
    fromDate: moment(
      getFiltersInfo()?.disbursements?.dateFilter?.startDate
    ).format('YYYY-MM-DD'),
    toDate: moment(getFiltersInfo()?.disbursements?.dateFilter?.endDate).format(
      'YYYY-MM-DD'
    ),
    rm: Object.keys(getFiltersInfo()?.disbursements?.rm || {})?.toString(),
    page: 0,
    pageSize: 50
  });

  const tableHead =
    'font-khand font-normal text-sm text-black-400 text-left py-4 px-2';
  const tableBody = `font-roboto font-normal  text-xs py-4 px-2 ${tableData}`;

  const commonUpperStyle = { maxHeight: '20px', maxWidth: '20px' };

  const rmImg = ({ className, style }) => (
    <SvgComponent
      img={rmICon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );
  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Date',
      name: 'date',
      component: DateFilter
    },
    {
      img: rmImg,
      title: 'RM',
      name: 'rm',
      component: RM
    }
  ];

  const getDisbursementData = filters => {
    setLoading(true);
    getBankDisbursementDetailReport(filters || disbursementFilters)
      .then(res => {
        setIsFirstCallDone(true);
        setPageInfo(res?.page);
        let data = res?._embedded?.leadDisbursementReportDtoList;
        setDisbursementData(preVal =>
          typeof data == 'object' ? [...preVal, ...data] : preVal
        );
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const getBankSummary = filters => {
    setIsLoadingSummary(true);
    getBankDisbusementSummary(filters || disbursementFilters)
      .then(res => {
        setSummaryData(res);
        setIsLoadingSummary(false);
      })
      .catch(error => {
        setIsLoadingSummary(false);
        setSummaryData({});
      });
  };

  useEffect(() => {
    getDisbursementData();
    getBankSummary();
  }, []);

  const handleInfiniteScroll = () => {
    let filters = {
      fromDate: disbursementFilters?.fromDate,
      toDate: disbursementFilters?.toDate,
      rm: disbursementFilters?.rm,
      page: ++disbursementFilters.page,
      pageSize: disbursementFilters?.pageSize
    };
    setDisbursementFilters(filters);
    getDisbursementData(filters);
  };
  const appledFilters = filters => {
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      disbursements: filters
    });
    setDisbursementData([]);
    let fiterObj = {
      fromDate: moment(filters?.dateFilter?.startDate).format('YYYY-MM-DD'),
      toDate: moment(filters?.dateFilter?.endDate).format('YYYY-MM-DD'),
      rm: Object.keys(filters?.rm || {})?.toString(),
      page: 0,
      pageSize: disbursementFilters?.pageSize
    };
    if (isFirstCallDone) {
      setDisbursementFilters(fiterObj);
      getDisbursementData(fiterObj);
      getBankSummary(fiterObj);
    }
  };

  return (
    <div className="w-full">
      <Helmet title={`Disbursement Report | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0">
        <div className="min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="w-full max-screen ">
            <div className="flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="mr-1 mt-1"
                  />
                  <span className="text-green-800">Disbursement report</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="flex w-full px-3 flex-wrap">
              <div
                className={`rounded border border-grey-1009 px-4 py-4  my-1 ${box_container}`}
              >
                <p className="text-black-400 font-roboto font-normal text-base text-left text-shadow-normal">
                  Total Disbursement
                </p>
                {isLoadingSummary ? (
                  <div className="table mx-auto mt-2">
                    <CircularProgress
                      style={{ width: '20px', height: '20px' }}
                    />
                  </div>
                ) : (
                  <p className="text-black-500 font-roboto font-bold text-2xl mt-1  text-left text-shadow-normal">
                    {numberFormat(summaryData?.totalDisbursement) || 0}
                  </p>
                )}
              </div>
              <div
                className={`rounded border border-grey-1009 px-4 py-4 my-1  ${box_container}`}
              >
                <p className="text-black-400 font-roboto font-normal text-base text-left text-shadow-normal">
                  Total Disbursement Amount
                </p>
                {isLoadingSummary ? (
                  <div className="table mx-auto mt-2">
                    <CircularProgress
                      style={{ width: '20px', height: '20px' }}
                    />
                  </div>
                ) : (
                  <p className="text-black-1011 font-roboto font-bold text-2xl  mt-1 text-left text-shadow-normal ">
                    ₹ {numberFormat(summaryData?.totalDisbursementAmount || 0)}
                  </p>
                )}
              </div>
              <div
                className={`rounded border border-grey-1009 px-4 py-4 my-1  ${box_container}`}
              >
                <p className="text-black-400 font-roboto font-normal text-base text-left text-shadow-normal">
                  Total Commission Amount
                </p>
                {isLoadingSummary ? (
                  <div className="table mx-auto mt-2">
                    <CircularProgress
                      style={{ width: '20px', height: '20px' }}
                    />
                  </div>
                ) : (
                  <p className="text-black-1011 font-roboto font-bold text-2xl  mt-1 text-left text-shadow-normal ">
                    ₹ {numberFormat(summaryData?.totalCommissionAmount || 0)}
                  </p>
                )}
              </div>
            </div>
            <div className="w-full px-2 py-4 sticky top-0">
              <div className={`bg-white  py-6 rounded ${table_container}`}>
                <div className="table border-grey-200  px-2 py-1 rounded border ml-4">
                  <CountsOfTheFilter filterData={shoHtmlSelectedFileds}>
                    <div
                      className="flex items-center pr-5 cursor-pointer"
                      onClick={() => setShowFilter(true)}
                    >
                      <FontAwesomeIcon
                        icon={faFilter}
                        className="text-blue-paleSky"
                      />
                      <p className="text-sm font-roboto font-normal ml-2 text-blue-paleSky">
                        Filter
                      </p>
                    </div>
                  </CountsOfTheFilter>
                </div>
                <div className="w-full flex flex-wrap  my-2 px-1">
                  {Object.keys(shoHtmlSelectedFileds || {}).map(
                    each => shoHtmlSelectedFileds[each]
                  )}
                </div>

                <InfiniteScroll
                  bottomLocation={30}
                  debounceTime={100}
                  handleScrollsuccess={handleInfiniteScroll}
                  disable={false}
                  pageInfo={pageInfo}
                  includeFilterLoder={loading}
                >
                  <div className="w-full">
                    <table className="w-full">
                      <thead>
                        <tr>
                          <td className={`${tableHead}`}>Lead ID</td>
                          <td className={`${tableHead}`}>Customer Name</td>
                          <td className={`${tableHead}`}> Bank</td>
                          <td className={`${tableHead}`}>RM Name</td>
                          <td className={`${tableHead}`}>Product</td>
                          <td className={`${tableHead}`}>Sub Product</td>
                          <td className={`${tableHead}`}>Disb date</td>
                          <td className={`${tableHead} text-right`}>
                            Disb amt
                          </td>
                          <td className={`${tableHead} text-right `}>
                            Payable Amount
                          </td>
                          <td className={`${tableHead} text-right pr-5`}>
                            Commission Percentage
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {disbursementData?.map((each, index) => (
                          <tr key={index} className={table_body}>
                            <td className={`${tableBody} text-black-0`}>
                              {each?.leadId || '---'}
                            </td>
                            <td className={`${tableBody} text-black-0`}>{`${each
                              ?.customerName?.firstName || ''} ${each
                              ?.customerName?.middleName || ''} ${each
                              ?.customerName?.lastName || ''} `}</td>
                            <td className={`${tableBody} text-black-850`}>
                              {each?.bankName || '---'}
                            </td>
                            <td
                              className={`${tableBody} text-black-0`}
                              style={{ minWidth: '120px' }}
                            >{`${each?.rmUserName?.firstName || ''} ${each
                              ?.rmUserName?.middleName || ''} ${each?.rmUserName
                              ?.lastName || ''}`}</td>
                            <td className={`${tableBody} text-black-850`}>
                              {each?.loanProduct || '---'}
                            </td>
                            <td className={`${tableBody} text-black-850`}>
                              {each?.loanSubProduct || '---'}
                            </td>
                            <td
                              className={`${tableBody} text-black-850`}
                              style={{ minWidth: '80px' }}
                            >
                              {each?.disbursedDate
                                ? moment(each?.disbursedDate)?.format(
                                    'DD-MM-YYYY'
                                  )
                                : '---'}
                            </td>
                            <td
                              className={`${tableBody} text-black-850 text-right `}
                              style={{ minWidth: '110px' }}
                            >
                              ₹ {numberFormat(each?.disbursedAmount || 0)}
                            </td>
                            <td
                              className={`${tableBody} text-black-850 text-right `}
                              style={{ minWidth: '110px' }}
                            >
                              ₹ {numberFormat(each?.amountPayable || 0)}
                            </td>{' '}
                            <td
                              className={`${tableBody} text-black-850 text-right pr-5`}
                            >
                              {each?.commissionPercentage
                                ? `${each?.commissionPercentage} %`
                                : '---'}
                            </td>
                          </tr>
                        ))}
                        {disbursementData?.length == 0 && !loading && (
                          <tr>
                            <td
                              colSpan="10"
                              className="text-center text-black-850 text-xs font-roboto "
                            >
                              No Disbursement Data Found!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopupFilter
        show={showFilter}
        setShow={setShowFilter}
        dataList={dataList}
        handleApply={appledFilters}
        handleToastBlock={e => setHtmlSelectedFileds(e)}
        masterFiltersData={masterFilters}
        styleContainer={{ maxWidth: '650px' }}
      />
    </div>
  );
};

export default DisbursementUI;
